import NotificationActionCreators from './NotificationActionCreators'
import { NotificationScopes } from '../AppConstants'

export const handleUploadError = (error: { message: string } | Error): void => {
  NotificationActionCreators.queueError({
    scope: NotificationScopes.FILE_UPLOAD,
    message: `⚠️ ${error.message}`,
  })
}
